import { useEffect } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../../../lib/client/client";

/**
 * Validates the session at app load
 * and clears expired data
 */
export const SessionValidator = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const queryClient = useQueryClient();

  useEffect(() => {
    // Check if token is expired on load
    if (!apiClient.isAuthenticated()) {
      // Token expired or missing, clear cache
      queryClient.clear();

      // If not on a public page, redirect to login
      const publicPaths = ["/login", "/reset-password", "/invite"];
      const currentPath = window.location.pathname;
      const isPublicPath = publicPaths.some((path) =>
        currentPath.startsWith(path)
      );

      if (!isPublicPath) {
        window.location.href = "/login";
      }
    }
  }, [queryClient]);

  return <>{children}</>;
};
